import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/utils.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  );
}

reportWebVitals();
